// src/utils/swal.js
// Tüm SweetAlert2 çağrıları buradan yapılır — tema merkezi olarak yönetilir
import Swal from 'sweetalert2';

// ── TEMA ──
const THEME = {
  confirmButtonColor: '#0f1f3d',
  cancelButtonColor:  '#6b6b7b',
  background:         '#ffffff',
  color:              '#1a1a2e',
};

// ── TOAST (sağ üstte kısa bildirim) ──
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  }
});

export const toast = {
  success: (message) => Toast.fire({
    icon: 'success',
    title: message,
    background: '#f0fdf4',
    color: '#166534',
    iconColor: '#2d7a4f',
  }),

  error: (message) => Toast.fire({
    icon: 'error',
    title: message,
    background: '#fef2f2',
    color: '#991b1b',
    iconColor: '#9b2335',
    timer: 4000,
  }),

  warning: (message) => Toast.fire({
    icon: 'warning',
    title: message,
    background: '#fffbeb',
    color: '#92400e',
    iconColor: '#c8a84b',
  }),

  info: (message) => Toast.fire({
    icon: 'info',
    title: message,
    background: '#eff6ff',
    color: '#1e40af',
  }),
};

// ── CONFIRM DIALOG (silme, önemli işlemler) ──
export const confirm = {
  delete: (itemName = 'bu öğeyi') =>
    Swal.fire({
      title: 'Emin misiniz?',
      text: `${itemName} silmek istediğinize emin misiniz?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#9b2335',
      cancelButtonColor:  '#6b6b7b',
      confirmButtonText: '🗑️ Evet, sil',
      cancelButtonText:  'İptal',
      background: THEME.background,
      color: THEME.color,
      reverseButtons: true,
    }),

  action: (title, text, confirmText = 'Evet') =>
    Swal.fire({
      title,
      text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: THEME.confirmButtonColor,
      cancelButtonColor:  THEME.cancelButtonColor,
      confirmButtonText: confirmText,
      cancelButtonText: 'İptal',
      background: THEME.background,
      color: THEME.color,
      reverseButtons: true,
    }),
};

// ── LOADING (uzun işlemler için) ──
export const loading = {
  show: (title = 'İşleniyor...') => Swal.fire({
    title,
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    background: THEME.background,
    color: THEME.color,
    didOpen: () => Swal.showLoading(),
  }),

  close: () => Swal.close(),
};

export default { toast, confirm, loading };
